/**
 * @flow
 * Created by neo on 18.07.17.
 */
import React, { Component } from 'react';
import { observer } from 'mobx-react';

type Props = {
  show: boolean
};

@observer
export default class DisplayToggle extends Component {
  
  props: Props;
  
  render() {
    if(this.props.show && this.props.children) {
      return React.Children.only(this.props.children);
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/App/Components/DisplayToggle.js